const CANONICAL_LENGTH = 14;

const BASE_PATTERN = /^[0-9A-Z]{12}[0-9]{2}$/;

/** Máscara vue-the-mask: 12 posições alfanuméricas + 2 dígitos verificadores. */
export const CNPJ_INPUT_MASK = 'XX.XXX.XXX/XXXX-##';

/**
 * Remove apenas a pontuação da máscara (. / -), preservando letras e dígitos.
 */
export function stripCnpjMask(value) {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    const stripped = String(value).replace(/[./-]/g, '');

    return stripped === '' ? null : stripped;
}

/**
 * Valor canônico: sem máscara, uppercase; pad à esquerda só para CNPJ 100% numérico.
 */
export function normalizeCnpj(value) {
    const stripped = stripCnpjMask(value);

    if (stripped === null) {
        return null;
    }

    let normalized = stripped.toUpperCase();

    if (/^\d+$/.test(normalized) && normalized.length < CANONICAL_LENGTH) {
        normalized = normalized.padStart(CANONICAL_LENGTH, '0');
    }

    return normalized;
}

/**
 * Aplica máscara XX.XXX.XXX/XXXX-DD sobre valor normalizado.
 */
export function formatCnpj(value) {
    const normalized = normalizeCnpj(value);

    if (normalized === null || normalized.length !== CANONICAL_LENGTH) {
        return value != null ? String(value) : '';
    }

    return `${normalized.substr(0, 2)}.${normalized.substr(2, 3)}.${normalized.substr(5, 3)}/${normalized.substr(8, 4)}-${normalized.substr(12, 2)}`;
}

/**
 * Valida CNPJ numérico ou alfanumérico (módulo 11 com conversão ASCII - 48).
 */
export function isValidCnpj(value) {
    const normalized = normalizeCnpj(value);

    if (normalized === null || normalized.length !== CANONICAL_LENGTH) {
        return false;
    }

    if (!BASE_PATTERN.test(normalized)) {
        return false;
    }

    if (new Set(normalized.split('')).size === 1) {
        return false;
    }

    const firstDigit = calculateCheckDigit(normalized.substring(0, 12));
    if (firstDigit !== parseInt(normalized.charAt(12), 10)) {
        return false;
    }

    const secondDigit = calculateCheckDigit(normalized.substring(0, 13));

    return secondDigit === parseInt(normalized.charAt(13), 10);
}

function charValue(char) {
    return char.charCodeAt(0) - 48;
}

function calculateCheckDigit(base) {
    const length = base.length;
    let sum = 0;
    let weight = length - 7;

    for (let i = length; i >= 1; i--) {
        sum += charValue(base.charAt(length - i)) * weight--;

        if (weight < 2) {
            weight = 9;
        }
    }

    const remainder = sum % 11;

    return remainder < 2 ? 0 : 11 - remainder;
}
